// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d969cf6e","517":"c3ade789","659":"fd04c409","665":"748da374","701":"0a07ed47","867":"eddc492b"}[chunkId] + ".chunk.js";
};